import { useSyncExternalStore } from 'react'

/**
 * Subscribe to a CSS media query. Used by BankPicker (AF-124) to swap a
 * Popover for a full-screen Dialog under 640px.
 *
 * Built on `useSyncExternalStore` so the snapshot is always consistent with
 * what `matchMedia` reports — no setState-in-effect cascade.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = (callback: () => void): (() => void) => {
    if (typeof window === 'undefined') return () => {}
    const mql = window.matchMedia(query)
    mql.addEventListener('change', callback)
    return () => mql.removeEventListener('change', callback)
  }
  const getSnapshot = (): boolean => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(query).matches
  }
  const getServerSnapshot = (): boolean => false
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
